<template>
    <div style="background-color: #f5f5f5; height: 100%">
        <div class="pa-5">
            <v-container class="my-5">
                <div class="logs">
                    <div v-for="(log, i) in logs" :key="i">
                           {{log}}
                    </div>
                </div>
            </v-container>
        </div>
    </div>
</template>
<script>

import axios from 'axios'

export default {
    data() {
        return {
            logs: null
        }
    },
    mounted() {
        axios.get('/api/logs').then(info => {
            this.logs = info.data.split('\n').reverse()
        })
    }
}
</script>